import { useThree } from '@react-three/fiber'
import React, { useEffect } from 'react'

// Renderer Settings as a separate component
export const RendererSettings = ({ toneMappingExposure }) => {
  const { gl } = useThree()
  useEffect(() => {
    gl.toneMappingExposure = toneMappingExposure
  }, [gl, toneMappingExposure])
  return null
}

export const RendererInfo = ({ materialsMap }) => {
  const { gl: renderer } = useThree()

  useEffect(() => {
    console.log(`🔍 Textures in memory: ${renderer.info.memory.textures}`)
  }, [materialsMap, renderer])

  return null
}
